/** Canonical platform list — mirrors PLATFORM_PORTS in the backend (app.ts). */
export const PLATFORMS = [
  { value: 'tungsten-pay', label: 'Tungsten Pay+ Backend' },
  { value: 'tungsten-network', label: 'Tungsten Network' },
  { value: 'tungsten-invoice', label: 'Tungsten Invoice Automation' },
  { value: 'tungsten-ap', label: 'Tungsten AP Automation' },
  { value: 'payplus', label: 'Pay+' },
  { value: 'sap', label: 'SAP ERP' },
  { value: 'oracle', label: 'Oracle Fusion' },
  { value: 'netsuite', label: 'NetSuite' },
] as const;

export const PLATFORM_LABELS: Record<string, string> = Object.fromEntries(
  PLATFORMS.map((p) => [p.value, p.label]),
);
